import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { User } from '../../types/User';

/** Why the login page is shown; it explains a sign-out the user did not ask for. */
export type SignOutNotice = 'passwordChanged';

interface AuthState {
    isAuthenticated: boolean;
    user: User | null;
    token: string | null;
    refreshToken: string | null;
    notice: SignOutNotice | null;
}

const initialState: AuthState = {
    isAuthenticated: false,
    user: null,
    token: null,
    refreshToken: null,
    notice: null,
};

// Initialize state from localStorage
const storedToken = localStorage.getItem('token');
const storedRefreshToken = localStorage.getItem('refreshToken');
const storedUser = localStorage.getItem('user');

if (storedToken && storedRefreshToken && storedUser) {
    initialState.isAuthenticated = true;
    initialState.token = storedToken;
    initialState.refreshToken = storedRefreshToken;
    initialState.user = JSON.parse(storedUser);
}

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setCredentials: (
            state,
            action: PayloadAction<{ user?: User; token: string; refreshToken: string }>
        ) => {
            state.isAuthenticated = true;
            state.user = action.payload.user || state.user;
            state.token = action.payload.token;
            state.refreshToken = action.payload.refreshToken;
            state.notice = null;

            // Save to localStorage
            localStorage.setItem('token', action.payload.token);
            localStorage.setItem('refreshToken', action.payload.refreshToken);
            if (action.payload.user) {
                localStorage.setItem('user', JSON.stringify(action.payload.user));
            }
        },
        logout: (state, action: PayloadAction<SignOutNotice | undefined>) => {
            state.notice = action.payload ?? null;
            state.isAuthenticated = false;
            state.user = null;
            state.token = null;
            state.refreshToken = null;

            // Remove from localStorage
            localStorage.removeItem('token');
            localStorage.removeItem('refreshToken');
            localStorage.removeItem('user');
        },
    },
});

export const { setCredentials, logout } = authSlice.actions;

export default authSlice.reducer;
